@if (notification.data.returnUrl) {
  <a [routerLink]="notification.data.returnUrl" (click)="onTriggerAction()" class="return-link">
    @if (notificationIcon) {
      <mat-icon
        class="notification-icon">
        {{ notificationIcon }}
      </mat-icon>
    }
    <p class="notification-text">
      {{ notificationText }}
    </p>
  </a>
  <button mat-icon-button
    class="close-button"
    (click)="onDismissNotification()">
    <mat-icon>close</mat-icon>
  </button>
} @else {
  @if (notificationIcon) {
    <mat-icon
      class="notification-icon">
      {{ notificationIcon }}
    </mat-icon>
  }
  <p class="notification-text"
    (click)="onTriggerAction()">
    {{ notificationText }}
  </p>
  <button mat-icon-button
    class="close-button"
    (click)="onDismissNotification()">
    <mat-icon>close</mat-icon>
  </button>
}

